import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {loginWithMicrosoftMutationType} from "./__graphql-types__/index.ts";

// TODO(miguel): Rename mutation to something that reflects the fact that
// loginWithMicrosoft generates a URL and does not do the actual login
// to Microsoft.
export const MICROSOFT_LOGIN_MUTATION: GqlOperation<
    loginWithMicrosoftMutationType["response"],
    loginWithMicrosoftMutationType["variables"]
> = gqlOp(gql`
    mutation loginWithMicrosoftMutation(
        $action: MicrosoftAuthAction
        $continueUrl: String
        $role: UserRole
    ) {
        loginWithMicrosoft(
            action: $action
            continueUrl: $continueUrl
            role: $role
        ) {
            redirectUrl
            error {
                code
            }
        }
    }
`);
